import TenancyCard from './TenancyCard';

export default TenancyCard;